import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "reducers/refills";
import * as refills from "middleware/refills";
import * as i18n from "util/i18n";
import { transactionStatus } from "pages/transactions/constants";
import { actions as notificationActions } from "reducers/notification";
import { selectors as sessionSelectors } from "reducers/session";
import { store } from "store";

const ticketStates = {
    COR023I: transactionStatus.PENDING,
    COR000I: transactionStatus.FINISHED,
    COR013I: transactionStatus.SCHEDULED,
};

const sagas = [
    takeLatest(types.GET_REFILLS_FORM_REQUEST, getFormRequest),
    takeLatest(types.PREPARE_REFILLS_FORM_REQUEST, preparePay),
    takeLatest(types.PAY_SERVICE_REQUEST, payService),
];

export default sagas;

function* getFormRequest() {
    const response = yield call(refills.getFormRequest);

    if (response.type === "W") {
        yield put({
            type: types.GET_REFILLS_FORM_FAILURE,
        });
    } else {
        yield put({
            type: types.GET_REFILLS_FORM_SUCCESS,
            formRequest: response.data.data.companies,
        });
    }
}

function* preparePay(request_data) {
    const response = yield call(refills.preparePay, { ...request_data });

    if (response.data.data.prepare.includes("errors")) {
        const arrayResponse = JSON.parse(response.data.data?.prepare);
        yield put(notificationActions.showNotification(arrayResponse?.errors[0].message, "error", ["refillsForm"]));

        yield put({
            type: types.PREPARE_REFILLS_FORM_FAILURE,
            refillsTicket: { status: "ERROR", idTransaction: "" },
        });
    } else {
        yield put({
            type: types.PREPARE_REFILLS_FORM_SUCCESS,
            refillsTicket: { status: "SUCCESS", idTransaction: "" },
        });
    }
}

function* payService({ paymentData, formikBag, credentialType }) {
    const { userId } = sessionSelectors.getUser(store.getState());
    const { setErrors } = formikBag;
    let params;
    try {
        params = { ...paymentData, userId, routeParam: "refills" };

        const response = yield call(refills.payService, params);

        if (response.data?.code === "COR020W") {
            yield put(
                notificationActions.showNotification(i18n.get("global.token.error"), "error", [
                    "refillsConfirmationPage",
                ]),
            );
            if (response.data?.data?.password) {
                const msj =
                    credentialType === "password"
                        ? "preferences.password.password.incorrect"
                        : "login.step1.secondFactor.invalid";
                setErrors({
                    credential: i18n.get(msj),
                });
                yield put(
                    notificationActions.showNotification(i18n.get("global.token.error"), "error", [
                        "refillsConfirmationPage",
                    ]),
                );
            }
            return;
        }
        yield put({
            type: types.PAY_SERVICE_SUCCESS,
            refillsTicket: {
                status: ticketStates[response.data.code],
                ...response.data,
            },
        });
        if (ticketStates[response.data.code] === ticketStates.COR000I) {
            yield put(
                notificationActions.showNotification(i18n.get("transfer.success"), "success", [
                    "refillsTransactionPage",
                ]),
            );
        }
    } catch (error) {
        yield put(notificationActions.showNotification(error.data.message, "error", ["refillsConfirmationPage"]));
        yield put({
            type: types.PAY_SERVICE_FAILURE,
            message: error.data.message,
        });
    } finally {
        credentialType.setSubmitting(false);
    }
}

/* MOCK
{
        requestList: [
            {
                code: "577",
                name: "NEXTEL...",
                paymentModeId: "49832290990200000210",
                maxAmmount: 200,
                minAmmount: 5,
                form: [
                    {
                        label: "Nro Linea",
                        position: 0,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IDC",
                        length: 20,
                    },
                    {
                        label: "Importe",
                        position: 1,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IMP",
                        length: 10,
                    },
                    {
                        label: "Combo box - Ejemplo",
                        position: 1,
                        dataType: "IMP",
                        component: "COMBO_BOX_ESTATICO",
                        inline: false,
                        field: "C11",
                        length: 2,
                        values: {
                            "0": "CEDULA DE IDENTIDAD",
                            "80": "CLAVE UNICA DE IDENTIFICACION TRIBUTARIA",
                            "86": "CLAVE UNICA DE IDENTIFICACION LABORAL",
                            "89": "LIBRETA DE ENROLAMIENTO",
                            "90": "LIBRETA CIVICA",
                            "94": "PASAPORTE",
                            "96": "DOCUMENTO NACIONAL DE IDENTIDAD",
                        },
                    },
                ],
            },
            {
                code: "16",
                name: "TELECOM PERSONAL ON",
                paymentModeId: "28437310883500007795",
                maxAmmount: 100,
                minAmmount: 15,
                form: [
                    {
                        label: "Hiden text - ejemplo",
                        position: 0,
                        dataType: "IMP",
                        component: "HIDDEN_TEXT_FIELD",
                        inline: false,
                        field: "IDC",
                        length: 20,
                    },
                    {
                        label: "Importe",
                        position: 1,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IMP",
                        length: 10,
                    },
                ],
            },
            {
                code: "1488",
                name: "MOVISTAR - RECARGAS DE CELULARRR",
                paymentModeId: "29453037476400000114",
                maxAmmount: 200,
                minAmmount: 5,
                form: [
                    {
                        label: "Nro Linea",
                        position: 0,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IDC",
                        length: 20,
                    },
                    {
                        label: "Importe",
                        position: 1,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IMP",
                        length: 10,
                    },
                ],
            },
            {
                code: "3144",
                name: "TUENTI - RECARGAS MOVILES",
                paymentModeId: "48396645639300000677",
                maxAmmount: 200,
                minAmmount: 5,
                form: [
                    {
                        label: "Nro Linea",
                        position: 0,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IDC",
                        length: 20,
                    },
                    {
                        label: "Importe",
                        position: 1,
                        dataType: "IMP",
                        component: "TEXT_FIELD",
                        inline: false,
                        field: "IMP",
                        length: 10,
                    },
                ],
            },
        ],
    }; */
